import {
  Breadcrumb,
  Button,
  Card,
  Divider,
  Form,
  Modal,
  Select,
  Tabs,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { accountListSelector } from "../../../../store/selectors/app.selector";
import { ReactComponent as RadioCheckIcon } from "../../../../assests/images/radioCheck.svg";
import { IoRadioButtonOff } from "react-icons/io5";
import AccountService from "../../../../services/accounts.service";
import Loader from "../../../../components/loader";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";

const defaultType = {
  week: false,
  month: false,
  quator: false,
  everyDay: false,
  everyWeek: false,
};

export default function EStamentRequestCasa() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [stopLoader, setStopLoader] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const accountList = useSelector(accountListSelector);
  const [form] = Form.useForm();
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [existingDetails, setExistingDetails] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [frequency, setFrequency] = useState({
    week: false,
    month: false,
    quator: false,
    everyDay: false,
    everyWeek: false,
  });
  const { t } = useTranslation();
  useEffect(() => {
    if (location.state) {
      if (location.pathname === "/accounts/statement/eStatement") {
        setActiveKey("E_STATEMENT");
      }
      setAccountDetails(location.state);
      getEStatementsDetails(location.state);
      form.setFieldsValue({ accountNo: location.state?.accountNo });
    }
  }, []);

  const handleChange = useCallback((type, value) => {
    try {
      setFrequency({ ...defaultType, [type]: true });
    } catch (error) {}
  }, []);

  // const handleTabClick = (key) => {
  //   setActiveKey(key);
  //   if (key === "ACCOUNT_DETAILS") {
  //     navigate("/accounts/summary", { state: accountDetails });
  //   }
  //   if (key === "MINI_STATEMENT") {
  //     navigate("/accounts/statement", { state: accountDetails });
  //   }
  //   if (key === "E_STATEMENT") {
  //     navigate("/accounts/statement/eStatement", {
  //       state: accountDetails,
  //     });
  //   }
  //   if (key === "VIEW_BALANCES") {
  //     navigate("/accounts/summary/balances", {
  //       state: accountDetails,
  //     });
  //   }
  // };

  const getEStatementsDetails = useCallback(async (data) => {
    try {
      setPageLoader(true);
      const response = await AccountService.getEStatementsDetails({});
      if (response.status === 200) {
        setPageLoader(false);
        setDataSource(response.data["data"]);
        setExistingDetails(
          response.data["data"].filter(
            (ele) => ele.accountNumber === data.accountNo
          )
        );
      }
      setPageLoader(false);
    } catch (error) {
      setPageLoader(false);
    }
  }, []);

  const onFinish = useCallback(
    async (values) => {
      try {
        if (!Object.values(frequency).includes(true)) {
          return;
        }
        const eDetails = dataSource?.find(
          (ele) => ele.accountNumber === values?.accountNo
        );
        const accDetails = accountList.find(
          (ele) => ele.accountNo === values?.accountNo
        );
        const reqParams = {
          accountNumber: values?.accountNo,
          branchId: accDetails?.branchId,
          everyWeek: frequency.week,
          everyMonth: frequency.month,
          everyQuarter: frequency.quator,
          everyDayCumulative: frequency.everyDay,
          everyWeekCumulative: frequency.everyWeek,
          stopRequest: false,
          id: eDetails?.id || null,
        };
        setLoader(true);
        const response = await AccountService.raiseEStatementRequest(reqParams);
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setVisible(true);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [frequency, dataSource, accountList]
  );

  const requestforEStatement = useCallback(async () => {
    try {
      const reqParams = {
        accountNumber: accountDetails?.accountNo,
        branchId: accountDetails?.branchId,
        everyWeek: false,
        everyMonth: false,
        everyQuarter: false,
        everyDayCumulative: false,
        everyWeekCumulative: false,
        stopRequest: true,
        id: existingDetails[0]?.id || null,
      };
      setStopLoader(true);
      const response = await AccountService.raiseEStatementRequest(reqParams);
      if (response.status === 200) {
        setStopLoader(false);
        setMessage(response.data["message"]);
        setVisible(true);
      }
    } catch (error) {
      setStopLoader(false);
    }
  }, [accountDetails, existingDetails]);

  const handleAccNoChange = useCallback(
    (value) => {
      try {
        setAccountDetails(accountList.find((ele) => ele.accountNo === value));
        setExistingDetails(
          dataSource.filter((ele) => ele.accountNumber === value)
        );
      } catch (error) {}
    },
    [accountList, dataSource]
  );

  //   const cancelEStatement = useCallback(())

  return (
    <>
      {/* 
       
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("buttons.e-Statement Request", {
                defaultValue: "e-Statement Request",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> }
            <h3 className="title mb-0">
              {t("buttons.e-Statement Request", {
                defaultValue: "e-Statement Request",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.gepeg.account_details", {
              defaultValue: "Account Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.gepeg.view_balances", {
              defaultValue: "View Balances",
            })}
            key="VIEW_BALANCES"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("navigation.statement", {
              defaultValue: "Statement",
            })}
            key="MINI_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.detailed_stmt_btn", {
              defaultValue: "Detailed Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.casa.eStatement_Request", {
                      defaultValue: "eStatement Request",
                    })}
            key="E_STATEMENT"
          ></Tabs.TabPane>
        </Tabs>
      </Card> */}
      <div className="row">
        <div className=" col-12 col-sm-12 col-md-12 col-lg-8">
          <Card className="application-card">
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <div className="row">
                <div className="col-12 col-sm-8 col-md-5 col-lg-5 ">
                  <Form.Item
                    label={t("common.account_no_lbl", {
                      defaultValue: "Account Number",
                    })}
                    name="accountNo"
                  >
                    <Select
                      placeholder={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      onChange={handleAccNoChange}
                      optionLabelProp={"value"}
                      size="large"
                    >
                      {accountList?.map((option, idx) => (
                        <Select.Option key={idx} value={option.accountNo}>
                          <span style={{ fontWeight: "bold" }}>
                            {option?.acctShortName}
                          </span>
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {option?.accountNo}
                          </span>
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {option?.branchName}
                          </span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-12 col-sm-12 col-md-10 col-lg-12">
                  <p>
                    {t("pages.my_accounts.casa.frequency_txt", {
                      defaultValue:
                        "Please select a frequency to start receiving your eStatement",
                    })}{" "}
                    : {accountDetails?.accountNo}
                  </p>

                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3">
                      <div
                        className="d-flex align-items-center"
                        onClick={() => handleChange("week", frequency.week)}
                        style={{ cursor: "pointer" }}
                      >
                        <span style={{ marginRight: 5 }}>
                          {!frequency.week && (
                            <IoRadioButtonOff style={{ fontSize: 20 }} />
                          )}
                          {frequency.week && (
                            <RadioCheckIcon height={17} width={17} />
                          )}
                        </span>
                        <span>
                          {t("pages.my_accounts.casa.every_week", {
                            defaultValue: "Every Week",
                          })}
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3">
                      <div
                        className="d-flex"
                        onClick={() => handleChange("month", frequency.month)}
                        style={{ cursor: "pointer" }}
                      >
                        <span style={{ marginRight: 5 }}>
                          {!frequency.month && (
                            <IoRadioButtonOff style={{ fontSize: 20 }} />
                          )}
                          {frequency.month && (
                            <RadioCheckIcon height={17} width={17} />
                          )}
                        </span>
                        <span>
                          {t("pages.my_accounts.casa.every_month", {
                            defaultValue: "Every Month",
                          })}{" "}
                        </span>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3">
                      <div
                        className="d-flex"
                        onClick={() => handleChange("quator", frequency.quator)}
                        style={{ cursor: "pointer" }}
                      >
                        <span style={{ marginRight: 5 }}>
                          {!frequency.quator && (
                            <IoRadioButtonOff style={{ fontSize: 20 }} />
                          )}
                          {frequency.quator && (
                            <RadioCheckIcon height={17} width={17} />
                          )}
                        </span>
                        <span>
                          {t("pages.my_accounts.casa.every_quarter", {
                            defaultValue: "Every Quarter",
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div
                    className="d-flex"
                    onClick={() => handleChange("everyDay", frequency.everyDay)}
                    style={{ cursor: "pointer" }}
                  >
                    <span style={{ marginRight: 10, paddingTop: 5 }}>
                      {!frequency.everyDay && (
                        <IoRadioButtonOff style={{ fontSize: 20 }} />
                      )}
                      {frequency.everyDay && (
                        <RadioCheckIcon height={17} width={17} />
                      )}
                    </span>
                    <span>
                      <span>
                        {t("pages.my_accounts.casa.every_day_cumulative", {
                          defaultValue: "Every day - Cumulative",
                        })}
                      </span>
                      <p>
                        {t("pages.my_accounts.casa.selecting_txt", {
                          defaultValue:
                            "On selecting this, you will receive incremental records in your statements every day starting from 1st of month",
                        })}
                      </p>
                    </span>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div
                    className="d-flex"
                    onClick={() =>
                      handleChange("everyWeek", frequency.everyWeek)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <span style={{ marginRight: 10, paddingTop: 5 }}>
                      {!frequency.everyWeek && (
                        <IoRadioButtonOff style={{ fontSize: 20 }} />
                      )}
                      {frequency.everyWeek && (
                        <RadioCheckIcon height={17} width={17} />
                      )}
                    </span>
                    <span>
                      <span>
                        {t("pages.my_accounts.casa.every_week_cumulative", {
                          defaultValue: "Every week - Cumulative",
                        })}
                      </span>
                      <p>
                        {t("pages.my_accounts.casa.selecting_week_txt", {
                          defaultValue:
                            "On selecting this, you will receive incremental records in your statements every week starting from 1st of month",
                        })}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex  mt-5 justify-content-between">
                <div>
                  <Button
                    loading={loader}
                    type="primary"
                    htmlType="submit"
                    disabled={!Object.values(frequency).includes(true)}
                    className="btn-primary"
                    size="large"
                  >
                    {existingDetails.length > 0
                      ? t("pages.my_accounts.casa.req_update_estmt_btn", {
                          defaultValue: "Request for Update eStatement",
                        })
                      : t("pages.my_accounts.casa.req_estmt_btn", {
                          defaultValue: "Request for eStatement",
                        })}
                  </Button>
                </div>

                {existingDetails.length > 0 && (
                  <div>
                    <Button
                      loading={stopLoader}
                      onClick={() => requestforEStatement()}
                      type="link"
                      size="large"
                      className="secondary-btn mx"
                    >
                      {t("pages.my_accounts.casa.stop_estmt_req_btn", {
                        defaultValue: "Stop eStatement Request",
                      })}
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          </Card>
        </div>
      </div>

      <Modal
        title={t("pages.my_accounts.casa.eStatement_Request", {
          defaultValue: "eStatement Request",
        })}
        open={visible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>{message}</p>
        <div align="right" className="mt-3">
          <Button
            type="link"
            onClick={() => {
              setVisible(false);
              navigate("/accounts/summary", { state: { ...location.state } });
            }}
          >
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
